import * as constants from './constants';

export const initialState = {
  newManufacturers: {},
  changedManufacturers: {},
  deletedManufacturers: {},
  newModels: {},
  changedModels: {},
  deletedModels: {},
  newGenerations: {},
  changedGenerations: {},
  deletedGenerations: {},
  newModifications: {},
  changedModifications: {},
  deletedModifications: {},
  newComplectations: {},
  changedComplectations: {},
  deletedComplectations: {},
  error: null,
};

const vehicleReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.RESET_ERROR:
    case constants.FETCH_CONFIRMATION_NEW_SUCCESS:
    case constants.FETCH_CONFIRMATION_NEW_FAIL:
    case constants.FETCH_CONFIRMATION_DELETED_SUCCESS:
    case constants.FETCH_CONFIRMATION_DELETED_FAIL:
    case constants.FETCH_CONFIRMATION_CHANGED_SUCCESS:
    case constants.FETCH_CONFIRMATION_CHANGED_FAIL:
    case constants.COPY_CONFIRMATION_SUCCESS:
    case constants.COPY_CONFIRMATION_FAIL:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default vehicleReducer;
